import { useRef } from 'react'
import {
  View,
  Text,
  TextInput,
  ActivityIndicator
} from 'react-native'
import { KeyboardAwareScrollView } from 'react-native-keyboard-aware-scroll-view'
import { globalStyles } from '../../../static/styles/global'
import HomeDetailsHeader from '../../home/HomeDetailsHeader'
import Card from '../../shared/card/Card'
import CustomButton from '../../shared/button/Button'
import { Formik } from 'formik'
import * as yup from 'yup'
import { useFormsStore } from '../../../stores/onboarding'
import { useInitializeStore } from '../../../stores/initialize'
import { usePersonalStore } from '../../../stores/personalInfo'
import Toast from 'react-native-toast-message'
import SelectKeyValue from '../../shared/form/SelectKeyValue'
import { mapSelectValue } from '../../../utils'


const CoinformationForm = ({ navigation, route }: any): JSX.Element => {
  const formikRef = useRef(null)
  const { params } = route
  const {
    mostRecentUserOnBoardings: userId,
    mode,
    essUserOnBoardingKey,
    essUserOnBoardingFormKey
  } = params


  const intialValues = {
    annualWithholdingAllowance: "",
    additionalWithholding: "",
    martialStatus: ""

  }
  const alschema = yup.object({
    annualWithholdingAllowance: yup.string().required("Annual Withholding Allowance is a required field"),
    additionalWithholding: yup.string().required("Additional Withholding is a required field"),
    martialStatus: yup.string().required("Marital Status is a required field")

  })
  const { loading, postcoonline } = useFormsStore()
  const initializestore = useInitializeStore()
  const personalstore = usePersonalStore()

  const options1 = [
    { key: 1, value: 'Single or Married Filing Seperately' },
    { key: 2, value: 'Head of Household' },
    { key: 3, value: 'Married Filing Jointly or Qualifying Surviving Spouse' }
  ]

  let description = ""








  return (
    <KeyboardAwareScrollView
      enableOnAndroid={true}
      enableAutomaticScroll={true}
      enableResetScrollToCoords={false}
      keyboardShouldPersistTaps="handled"
      keyboardDismissMode="interactive"
      showsVerticalScrollIndicator={false}
      extraScrollHeight={80}
      contentContainerStyle={{ flexGrow: 1, paddingBottom: 20 }}
    >
      <View style={[globalStyles.primaryBgColor, globalStyles.containerBand]}>
        <View style={[globalStyles.horizontalPadGap]}>
          <HomeDetailsHeader
            navLabel="Forms"
            navScreen="OnboardingForms"
            title={'CO Withholding Taxation'}
          />
        </View>
      </View>
      <View style={globalStyles.containerOverlap}>
        <Formik
          initialValues={{ ...intialValues }}
          validationSchema={alschema}
          onSubmit={async (values, actions) => {

            const data = {
              completeOnline: mode === 'online' ? true : false,
              essUserKey: initializestore.initializeData.userkey,
              entityId: personalstore.personalData?.entityId,
              essUserOnBoardingFormKey: essUserOnBoardingFormKey,
              essObKey: essUserOnBoardingKey,
              AnnualWithholdingAllowance: Number(values?.annualWithholdingAllowance) || null,
              AdditionalWperPayPeriod: Number(values?.additionalWithholding) || null,
              filingStatus: description
            }

            const response = await postcoonline(data)
            if (response?.success) {
              if (mode === 'upload') {
                await Toast.show({
                  type: 'success',
                  position: 'bottom',
                  text1: response?.message,
                  visibilityTime: 3000,
                  autoHide: true,
                  topOffset: 60,
                  onHide: () => {
                    navigation.replace('OnboardingForms')
                  }
                })
              } else {
                navigation.navigate('Coonline', {
                  userId,
                  mode,
                  essUserOnBoardingKey,
                  essUserOnBoardingFormKey,
                  values,
                  description
                })
              }
            } else {
              await Toast.show({
                type: 'error',
                position: 'bottom',
                text1: response?.message,
                visibilityTime: 3000,
                autoHide: true,
                topOffset: 60
              })
            }
          }}
        >
          {(props) => (
            <>
              <Card>
                <View
                  style={[
                    globalStyles.hDirection,
                    globalStyles.hBetweenItems,
                    globalStyles.mb2
                  ]}
                >
                  <View style={{ justifyContent: 'center', width: '50%' }}>
                    <Text
                      style={[
                        globalStyles.inputLabel,
                        globalStyles.inputLabelLarge,
                        globalStyles.inputLabelPrimary
                      ]}
                    >
                      {'Marital Status *'}
                    </Text>
                  </View>
                  <View style={{ width: '28%', overflow: 'hidden' }}>
                    <SelectKeyValue
                      title="Marital Status"
                      options={options1}
                      selectedOption={mapSelectValue(
                        options1,
                        props.values.martialStatus
                      )}
                      onSelect={(option: any) => {
                        props.setFieldValue('martialStatus', option - 1)
                        if (option == 1) {
                          description = "Single or Married Filing Seperately"
                        }
                        if (option == 2) {
                          description = 'Head of Household'
                        }
                        if (option == 3) {
                          description = 'Married Filing Jointly or Qualifying Surviving Spouse'
                        }
                      }}
                      textColor="primary"
                    />
                    {props.touched.martialStatus &&
                      props.errors.martialStatus && (
                        <Text style={globalStyles.dangerAlert}>
                          {props.errors.martialStatus}
                        </Text>
                      )}
                  </View>
                </View>


                <View
                  style={[
                    globalStyles.hDirection,
                    globalStyles.hBetweenItems,
                    globalStyles.mb2
                  ]}
                >
                  <View style={{ justifyContent: 'center', width: '50%' }}>
                    <Text
                      style={[
                        globalStyles.inputLabel,
                        globalStyles.inputLabelLarge,
                        globalStyles.inputLabelPrimary
                      ]}
                    >
                      <Text>
                        To reduce your Colorado withholding, either:{"\n"}
                        a. Enter the amount from Table 1 for your federal standard deduction and number of jobs; or{"\n"}
                        b. Enter the result from Worksheet 1, if you expect to claim additional federal deductions or Colorado tax credits, or if you (and your spouse, if filing jointly) have multiple jobs but earn most of your income from one job.{"\n\n"}
                        If you want a greater amount withheld, you may enter a smaller amount than either calculation, including zero, and/or you may complete Line 3 *
                      </Text>
                    </Text>
                  </View>
                  <View style={{ width: '28%', overflow: 'hidden' }}>
                    <TextInput
                      style={[globalStyles.input, globalStyles.inputLight]}
                      value={props.values.annualWithholdingAllowance}
                      keyboardType="numeric"
                      onChangeText={(text) => {
                        if (text === '' || /^\d+$/.test(text)) {
                          props.handleChange('annualWithholdingAllowance')(text)
                        }
                      }}
                    />

                    {props.touched.annualWithholdingAllowance &&
                      props.errors.annualWithholdingAllowance && (
                        <Text style={globalStyles.dangerAlert}>
                          {props.errors.annualWithholdingAllowance as string}
                        </Text>
                      )}
                  </View>
                </View>

                <View
                  style={[
                    globalStyles.hDirection,
                    globalStyles.hBetweenItems,
                    globalStyles.mb2
                  ]}
                >
                  <View style={{ justifyContent: 'center', width: '50%' }}>
                    <Text
                      style={[
                        globalStyles.inputLabel,
                        globalStyles.inputLabelLarge,
                        globalStyles.inputLabelPrimary
                      ]}
                    >
                      {'Additional withholding amount per pay period *'}
                    </Text>
                  </View>
                  <View style={{ width: '28%', overflow: 'hidden' }}>
                    <TextInput
                      style={[globalStyles.input, globalStyles.inputLight]}
                      value={props.values.additionalWithholding}
                      keyboardType="numeric"
                      onChangeText={(text) => {
                        if (text === '' || /^\d+$/.test(text)) {
                          props.handleChange('additionalWithholding')(text)
                        }
                      }}
                    />

                    {props.touched.additionalWithholding &&
                      props.errors.additionalWithholding && (
                        <Text style={globalStyles.dangerAlert}>
                          {props.errors.additionalWithholding as string}
                        </Text>
                      )}
                  </View>
                </View>
                {loading ? (
                  <ActivityIndicator />
                ) : (
                  <View style={{ margin: 10 }}>
                    <CustomButton
                      text={mode === 'upload' ? 'Submit Information' : 'Next'}
                      onPress={props.handleSubmit}
                    />
                  </View>
                )}
              </Card>

            </>
          )}
        </Formik>
      </View>

    </KeyboardAwareScrollView>
  )
}
export default CoinformationForm
